import { defineComponent as _defineComponent } from 'vue'
import { TransportationWaypointSortingPreview } from './WaypointSortingDialog.vue'
import WaypointSortPreviewTransportations from './WaypointSortPreviewTransportations.vue'
import IndexAvatar from '@/components/trip/travelPlan/IndexAvatar.vue'
import { DateRange } from '@/types/trip'
import { localizedDateRange } from '@/utils/date-utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'WaypointSortPreview',
  props: {
    waypoints: null
  },
  setup(__props: any) {



return { __sfc: true,WaypointSortPreviewTransportations, IndexAvatar, localizedDateRange }
}

})